export default __webpack_public_path__ + "static/luke_carrying_chimp-rs-e7e81763dee80f2bdb8488661e2cae9f.jpg";